import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import debounce from 'lodash.debounce';

interface IProps {
    inputValue?: string;
    placeholder?: string;
    debounceTime?: number;
    onSearch(query: string): any;
}

const Search = ({ inputValue = '', placeholder = '', debounceTime = 700, onSearch }: IProps) => {

    const [value, setValue] = useState(inputValue);

	const debouncedSave = useCallback(
		debounce(nextValue => {
            onSearch(nextValue)
        }, debounceTime),
		[], 
	);	

	const handleChange = event => {
		const { value: nextValue } = event.target;
        
		setValue(nextValue);		
		debouncedSave(nextValue);
	};

    useEffect(() => {
        setValue(inputValue)
    }, [inputValue])

  
    return <Container>
            <input type="text" className="search no-box-shadow" onChange={handleChange}
                placeholder={i18n(placeholder)} value={value} />
    </Container>
}

export default React.memo(Search);

const Container = styled.div`
    
`



